import RfiAnalyticsInstance from './RfiAnalyticsInstance.component';

export default RfiAnalyticsInstance;